import styles from "../../../../../assets/scss/common/modal/signupModal.module.scss";
import {Timer} from "../Timer";
import React, {useCallback, useEffect, useRef, useState} from "react";
import {getConfirmEmail} from "../../../../../store/singup/signupSlice";
import {ErrorType} from "../../../../../types/error";
import {useAppDispatch, useModal, useUserAgent} from "../../../../../hooks/hooks";
import {SignupStatus} from "../../SignupModal";
import {ModalType} from "../../../../../types/common";
import {getOnlyNumberText} from "../../../../../util/commonFunctions";
import {Trans, useTranslation} from "react-i18next";

interface Props {
    email: string;
    changeSignupStep: (_: SignupStatus) => void;
    setTitle: (_: string) => void;
    setCode: (_: string) => void;
}

export function SignupStep(
    {
        email,
        changeSignupStep,
        setTitle,
        setCode
    }: Props) {
    const {t} = useTranslation("signupModal");
    const LOGIN_BLOCK_SEC = 5 * 60;

    const codeFormRef = useRef<HTMLFormElement>(null);
    const [isHovered, setIsHovered] = useState(false);


    const [loginCode, setLoginCode] = useState("");
    const [alertMessage, setAlertMessage] = useState("");
    const [canLogin, setCanLogin] = useState(true);
    const dispatch = useAppDispatch();
    const {openModal} = useModal();
    // const onClickCloseBtn = () => closeModal();
    const {isMobile} = useUserAgent();

    useEffect(() => {
        setTitle(t("signup.title"))
    });

    const onClickCancelBtn = useCallback(
        (e: React.MouseEvent) => {
            e.stopPropagation();
            setAlertMessage("");
            openModal(ModalType.LOGIN)
        },
        // eslint-disable-next-line
        [changeSignupStep]
    );

    const emailConfirm = useCallback(
        async (email: string, code: string) => {
            try {
                return await dispatch(getConfirmEmail({email, code})).unwrap();
            } catch (e) {
                console.error(e);
                const errorMessage = (e as { message: string }).message;
                const error: ErrorType = JSON.parse(errorMessage);
                console.log(errorMessage);
                console.log(error.errorCode.msg);
                const isLoginPossible = (error.data as { incorrect_count: string }).incorrect_count === '5'
                if (isLoginPossible) {
                    setAlertMessage(t("warning.authenticate.cancelAuthenticCode"));
                    setCanLogin(false);
                    setTitle(t("signupAndLogin.title"));
                } else {
                    const incorrectCount = (error.data as { incorrect_count: string }).incorrect_count;
                    setAlertMessage(`${t("warning.authenticate.wrongAuthenticCode")} (${incorrectCount}/5회)`);
                }

                throw e;
            }
        },
        // eslint-disable-next-line
        [dispatch]
    );

    const onClickNextStep = useCallback(() => {
        if (loginCode !== '' && getOnlyNumberText(loginCode)) {
            emailConfirm(email, loginCode).then((result) => {
                changeSignupStep(SignupStatus.Sign_UP_INFO_01);
                setCode(loginCode)
            }).catch((error) => {
            });
        } else if (!getOnlyNumberText(loginCode) && loginCode !== '') {
            setAlertMessage(t("warning.authenticate.wrongType"))
        } else if (loginCode === '') {
            setAlertMessage(t("warning.authenticate.empty"))
        } else {
            setAlertMessage(t("warning.authenticate.tryAgain"))
        }
        // eslint-disable-next-line
    }, [loginCode])


    const doAtTheEnd = useCallback(() => {
        setAlertMessage(t("warning.authenticate.timeExceed"))
        setCanLogin(false);

        // eslint-disable-next-line
    }, []);


    return (
        <div className={styles.authenticationContent}>
            <div className={styles.textDesc}>
                <div className={styles.desc}>
                    <Trans t={t} i18nKey={isMobile ? "signup.desc1Mo" : "signup.desc1"}
                           values={{email: email}}
                           components={{accent: <span className={styles.accent}/>, br: <br/>}}
                    />
                </div>
                <form className={styles.emailForm} onSubmit={(e) => e.preventDefault()} ref={codeFormRef}>
                    <input
                        type="tel"
                        className={styles.input}
                        value={loginCode}
                        onInvalid={(e) => e.preventDefault()}
                        onChange={(e) => setLoginCode(e.target.value.toUpperCase())}
                        placeholder={t("signup.placeholder")}
                    />
                    {canLogin ? (
                        <Timer initialMilliseconds={LOGIN_BLOCK_SEC * 1000} styleClassName={styles.timer}
                               doAtTheEnd={doAtTheEnd}
                        />
                    ) : (
                        <></>
                    )}
                    {alertMessage ? <span className={styles.invalidEmailAddr}>{alertMessage}</span> : <></>}
                    <div className={`${styles.buttonsWrapper} ${styles.withMarginTop}`}>
                        <button type="button" className={styles.outlineButton}
                                onClick={onClickCancelBtn}
                        >
                            {t('btn.cancel')}
                        </button>
                        {canLogin ? (
                            <button type="button"
                                    className={`${styles.authenticationNextButton} ${isHovered ? styles.authenticationNextHoverButton : ''}`}
                                    onMouseEnter={() => setIsHovered(true)}
                                    onMouseLeave={() => setIsHovered(false)}
                                    onClick={onClickNextStep}
                            >
                                {t('btn.next')}
                            </button>
                        ) : (
                            <></>
                        )}
                    </div>
                </form>
            </div>
        </div>
    )
}